import { motion } from 'framer-motion';

/**
 * StageMaskBackdrop (parity #2) — a faint, slowly-drifting set of
 * comedy/tragedy theater masks behind the Stage arena. Purely
 * decorative (aria-hidden, pointer-events:none) and sits at z-index 0
 * so the entity sprites + score floaters always render above it. Ties
 * the arena visually back to the splash/auth orbiting-mask motif.
 */
const MASKS = [
  { left: '7%',  top: '16%', size: 92,  dur: 17, delay: 0,   drift: 16, rot: 6 },
  { left: '71%', top: '11%', size: 70,  dur: 21, delay: 2.4, drift: 22, rot: -8 },
  { left: '45%', top: '58%', size: 112, dur: 25, delay: 1.1, drift: 18, rot: 5 },
  { left: '84%', top: '63%', size: 62,  dur: 19, delay: 3.3, drift: 14, rot: -6 },
  { left: '19%', top: '70%', size: 78,  dur: 23, delay: 0.7, drift: 20, rot: 7 },
];

export default function StageMaskBackdrop() {
  return (
    <div
      className="absolute inset-0 pointer-events-none overflow-hidden"
      style={{ zIndex: 0 }}
      aria-hidden="true"
      data-testid="stage-mask-backdrop"
    >
      {MASKS.map((m, i) => (
        <motion.img
          key={i}
          src="/masks.png"
          alt=""
          className="absolute"
          style={{
            left: m.left,
            top: m.top,
            width: m.size,
            height: m.size,
            objectFit: 'contain',
            opacity: 0.07,
            filter: 'grayscale(1) drop-shadow(0 0 6px rgba(190,150,255,0.25))',
          }}
          animate={{ y: [0, -m.drift, 0], rotate: [0, m.rot, 0] }}
          transition={{ duration: m.dur, delay: m.delay, repeat: Infinity, ease: 'easeInOut' }}
          onError={(e) => { e.currentTarget.style.display = 'none'; }}
        />
      ))}
    </div>
  );
}
